export const APP_NAME = 'DreamPick';
export const APP_TAGLINE = 'Premium Electric Mobility';

export const ROUTES = {
  home: '/',
  auth: {
    login: '/auth/login',
    register: '/auth/register',
    forgot: '/auth/forgot-password',
  },
  customer: {
    dashboard: '/dashboard',
    wallet: '/dashboard/wallet',
    referrals: '/dashboard/referrals',
    tree: '/dashboard/tree',
  },
  admin: {
    root: '/admin',
    users: '/admin/users',
    payouts: '/admin/payouts',
    settings: '/admin/settings',
  },
} as const;

export const QUERY_KEYS = {
  me: ['auth', 'me'] as const,
  users: ['users'] as const,
  plans: ['plans'] as const,
} as const;
